
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor2On as ObiResistor2OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-2-on.js';
 
 
 

 
 export const ObiResistor2On = createComponent({
   react: React,
   tagName: 'obi-resistor-2-on',
   elementClass: ObiResistor2OnElement,
   events: {
     
   }
  });
 
 